import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const DispatchOrchestrationService = lazyWithRetry(() => import('./DispatchOrchestrationService'));

const DispatchOrchestrationServiceRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="dispatch-orchestration-service-mf">
      <Switch>
        <Route
          path={path}
          render={() => (
            <LazyComponent>
              <DispatchOrchestrationService />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default DispatchOrchestrationServiceRoutes;
